import { z } from 'zod'

export const termLifeSchema = z.object({
  // since who benefits accepts more multiple answers, the options are rendered in checkboxes, which outputs an object of booleans
  // however, zapier expects an array of strings, so we use the pre process to convert only the checked fields
  who_benefits: z.preprocess((values) => {
    const valuesCopy = { ...(values as Record<string, boolean | undefined>) }
    return Object.keys(valuesCopy).filter((key) => valuesCopy[key])
  }, z.array(z.string()).nonempty()),
  loan: z.enum(['yes', 'no', 'dont_know']),
  insured_sum: z.enum(['150k', '300k', '500k', 'other', 'dont_know']),
  employment_status: z.enum([
    'permanently_employed',
    'civil_servant',
    'student',
    'apprentice',
    'self_employed',
    'retired',
    'other',
  ]),
  income: z.enum(['less_than_30k', '30k_to_50k', '50k_to_74k', 'more_than_74k']),
})
